export function enableFloatingHeader() {
    const originalHeader = document.querySelector('header.wp-block-template-part');

    if (!originalHeader) {
        console.warn('Original header not found');
        return;
    }

    const originalPosition = originalHeader.style.position || '';
    const originalTop = originalHeader.style.top || '';
    const originalLeft = originalHeader.style.left || '';
    const originalWidth = originalHeader.style.width || '';
    const originalZIndex = originalHeader.style.zIndex || '';
    const originalBoxShadow = originalHeader.style.boxShadow || '';
    const originalBodyPaddingTop = document.body.style.paddingTop || '';

    const headerHeight = originalHeader.offsetHeight;

    const auxElement = originalHeader.querySelector('.header__aux');
    const originalAuxDisplay = auxElement ? auxElement.style.display || '' : '';

    const mainHeader = originalHeader.querySelector('.header__main');
    const originalMainMarginTop = mainHeader ? mainHeader.style.marginTop || '' : '';

    const triggerPoint = originalHeader.offsetTop + originalHeader.offsetHeight / 2;
    const headerElement = originalHeader.querySelector('.header');

    window.addEventListener('scroll', () => {
        if (window.scrollY > triggerPoint) {
            originalHeader.style.position = 'fixed';
            originalHeader.style.top = '0';
            originalHeader.style.left = '0';
            originalHeader.style.width = '100%';
            originalHeader.style.zIndex = '9999';
            originalHeader.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';

            if (headerElement) {
                headerElement.classList.add('fixed-header');
            }

            document.body.style.paddingTop = `${headerHeight}px`;

            if (auxElement) {
                auxElement.style.display = 'none';
            }

            if (mainHeader) {
                mainHeader.style.marginTop = '0';
            }
        } else {
            originalHeader.style.position = originalPosition;
            originalHeader.style.top = originalTop;
            originalHeader.style.left = originalLeft;
            originalHeader.style.width = originalWidth;
            originalHeader.style.zIndex = originalZIndex;
            originalHeader.style.boxShadow = originalBoxShadow;

            if (headerElement) {
                headerElement.classList.remove('fixed-header');
            }

            document.body.style.paddingTop = originalBodyPaddingTop;

            if (auxElement) {
                auxElement.style.display = originalAuxDisplay;
            }

            if (mainHeader) {
                mainHeader.style.marginTop = originalMainMarginTop;
            }
        }
    });
}
